export default __webpack_public_path__ + "static/media/header-background.b5e04a8f.png";